import { z } from 'zod';

/**
 * The trip event log (gitaumoses4/chukua#43). Trip status is derived from these events, so the list
 * is the vocabulary the M4/M5 producers write. The `trip_events_*_check` constraints in
 * `dispatch.schema.ts` hard-code the same values; adding one means a migration. The milestone
 * names (`departed` … `unloaded`) are provisional until the first producer exists.
 * A correction is any event whose `corrects_event_id` is set; its type says what the corrected fact now is.
 */
export const TRIP_EVENT_TYPES = [
  'trip_opened',
  'dispatched',
  'accepted',
  'driver_confirmed',
  'departed',
  'stop_reached',
  'arrived',
  'loaded',
  'unloaded',
  'location_pinged',
  'fuel_stop',
  'exception',
  'pod_captured',
] as const;
export type TripEventType = (typeof TRIP_EVENT_TYPES)[number];
export const tripEventTypeSchema = z.enum(TRIP_EVENT_TYPES);

/** Who or what wrote the event: office staff, the driver's app, a GPS feed or the platform itself. */
export const TRIP_EVENT_SOURCES = ['office', 'driver_app', 'gps', 'system'] as const;
export type TripEventSource = (typeof TRIP_EVENT_SOURCES)[number];
export const tripEventSourceSchema = z.enum(TRIP_EVENT_SOURCES);
